import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import './FAQ.css';

const FAQ = () => {
  const [openItems, setOpenItems] = useState(new Set([0])); // First item open by default

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const headerHeight = 80;
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const elementTop = rect.top + scrollTop;
      const targetPosition = elementTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  };

  const faqs = [
    {
      question: "What subjects and grade levels do you offer tutoring for?",
      answer: "We provide tutoring across the full UK curriculum, including Maths, English, Sciences (Biology, Chemistry, Physics), Humanities, Languages, and Creative Arts. Lessons are available for Key Stages 1–5 (Primary, Secondary, GCSE, A-Level), as well as support for Common Entrance and specialized subjects."
    },
    {
      question: "How does one-on-one online tutoring work?",
      answer: "Our one-on-one online tutoring connects students directly with a qualified tutor in a secure virtual classroom. Sessions use video calls, interactive whiteboards, screen sharing, and digital resources—allowing for real-time feedback and tailored teaching aligned with the student's school curriculum."
    },
    {
      question: "How do I book a tutoring session?",
      answer: "Simply contact us to arrange an initial assessment and a free demo class. Once you're happy with the tutor, we'll share personalised packages tailored to your child's needs. You can then choose to pay monthly (pay-as-you-go) or opt for a discounted yearly package."
    },
    {
      question: "Do you offer a free trial class?",
      answer: "Yes! We provide a free assessment session and a free demo class so you can experience our one-on-one online tutoring and see how we tailor learning to your needs before choosing a package."
    },
    {
      question: "Can I reschedule or cancel a lesson?",
      answer: "You may reschedule or cancel a lesson by contacting us. We understand that schedules can change and we're flexible to accommodate your needs."
    },
    {
      question: "How much does a session cost, and do you offer packages?",
      answer: "Our prices start from £6.90 per hour for primary students and may vary for higher classes such as GCSEs and A-Levels. We offer both monthly pay-as-you-go options and discounted annual packages. There are no registration fees or hidden charges — you only pay for the lessons you choose."
    },
    {
      question: "Can I switch tutors if I'm not satisfied?",
      answer: "Yes, absolutely. Just contact us, and we'll arrange a new tutor for your child. Your child's learning experience is our top priority, and we work to ensure the best possible match for every student."
    },
    {
      question: "How is my child's progress tracked and shared?",
      answer: "We track progress through detailed lesson notes, regular assessments, and personalised progress reports, which are shared with parents at regular intervals to keep you fully informed of your child's learning journey."
    }
  ];

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  return (
    <section className="faq section" id="faq">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h2>
          <p className="section-description">
            Find answers to common questions about our tutoring services
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item"
            >
              <button
                className={`faq-question ${openItems.has(index) ? 'active' : ''}`}
                onClick={() => toggleItem(index)}
              >
                <span className="question-text">{faq.question}</span>
                <div className="question-icon">
                  {openItems.has(index) ? (
                    <Minus className="icon" />
                  ) : (
                    <Plus className="icon" />
                  )}
                </div>
              </button>
              
              <div className="faq-answer">
                <div className="answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <div className="cta-card premium-card">
            <h3 className="cta-title">Still have questions?</h3>
            <p className="cta-text">
              Our team is here to help you find the perfect tutoring solution for your needs.
            </p>
            <button className="btn-primary" onClick={scrollToContact}>
              Contact Us Today
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
